export function ensure<T>(
  arg: T | undefined,
  msg = 'This value was promised to be there!'
): T {
  if (typeof arg === 'undefined') {
    throw new TypeError(msg);
  }

  return arg;
}
